import { JOUR } from '@/configuration/devisConf';
import { genererLigneEcheancierForAuto } from '@/services/devisCommandes/echeanciers/genererLigneEcheancier';

export default function genererEcheancierAuto() {
  return {
    openEcheancierLignes: false,
    echeancierLignes: [genererLigneEcheancierForAuto()],
    dateDebut: null,
    dateFin: null,
    dateFinPremiereEcheance: null,
    quantitePeriodicite: 0,
    unitePeriodicite: JOUR,
    select: false,
  };
}
